<template>
  <div v-if="getValue(column, 'tipo') == 'FECHA' || getValue(column, 'tipo') == 'FECHAHORA'" :class="{'label-group': tipo == 'FILTRO', 'filtro-fecha-group': tipo == 'FILTRO'}">
    <template v-if="tipo == 'FILTRO'">
      <li><label>{{$t(column.nombre)}}</label></li>
      <div v-if="chipFiltro" class="filtro-nav-rango">
        <f7-link @click="navegarFecha(-1)" :tooltip="$t('common.anterior')" class="filtro-nav-link"><f7-icon f7="chevron_left"></f7-icon></f7-link>
        <span class="filtro-nav-chip">{{ chipFiltro }}</span>
        <f7-link @click="navegarFecha(1)" :tooltip="$t('common.siguiente')" class="filtro-nav-link"><f7-icon f7="chevron_right"></f7-icon></f7-link>
      </div>
      <div class="filtro-iconos-rango">
        <f7-link
          @click="toggleFiltroFecha('anyoActual', 'AnyoActual')"
          :tooltip="$t('common.anyoActual')"
          :class="{'filtro-icon-activo': !!form && !!form.getValue(getPathName(column) + 'AnyoActual')}"
          class="filtro-icon"
        ><f7-icon f7="calendar_circle"></f7-icon></f7-link>
        <f7-link
          @click="toggleFiltroFecha('mesActual', 'MesActual')"
          :tooltip="$t('common.mesActual')"
          :class="{'filtro-icon-activo': !!form && !!form.getValue(getPathName(column) + 'MesActual')}"
          class="filtro-icon"
        ><f7-icon f7="calendar"></f7-icon></f7-link>
        <f7-link
          @click="toggleFiltroFecha('semanaActual', 'SemanaActual')"
          :tooltip="$t('common.semanaActual')"
          :class="{'filtro-icon-activo': !!form && !!form.getValue(getPathName(column) + 'SemanaActual')}"
          class="filtro-icon"
        ><f7-icon f7="square_grid_2x2"></f7-icon></f7-link>
        <f7-link
          @click="toggleFiltroFecha('diaActual', 'DiaActual')"
          :tooltip="$t('common.diaActual')"
          :class="{'filtro-icon-activo': !!form && !!form.getValue(getPathName(column) + 'DiaActual')}"
          class="filtro-icon"
        ><f7-icon f7="calendar_today"></f7-icon></f7-link>
      </div>
      <div style="display:none;">
        <r-input
          ref="diaActual"
          :form="form"
          :simple="true"
          type="check"
          :name="getPathName(column) + 'DiaActual'"
          @change="diaActual"
        ></r-input>
        <r-input
          ref="semanaActual"
          :form="form"
          :simple="true"
          type="check"
          :name="getPathName(column) + 'SemanaActual'"
          @change="semanaActual"
        ></r-input>
        <r-input
          ref="mesActual"
          :form="form"
          :simple="true"
          type="check"
          :name="getPathName(column) + 'MesActual'"
          @change="mesActual"
        ></r-input>
        <r-input
          ref="anyoActual"
          :form="form"
          :simple="true"
          type="check"
          :name="getPathName(column) + 'AnyoActual'"
          @change="anyoActual"
        ></r-input>
      </div>
      <r-input
        ref="fechaVacia"
        floating-label
        outline
        :label="$t('common.fechaVacia')"
        :form="form"
        :simple="true"
        type="check"
        :name="getPathName(column) + 'FechaVacia'"
        @change="fechaVacia"
      ></r-input>
      <r-input
        ref="fechaRellena"
        floating-label
        outline
        :label="$t('common.fechaRellena')"
        :form="form"
        :simple="true"
        type="check"
        :name="getPathName(column) + 'FechaRellena'"
        @change="fechaRellena"
      ></r-input>
      <r-input
        ref="fechaDesde"
        v-if="!!form && !form.getValue(getPathName(column) + 'FechaVacia') && !form.getValue(getPathName(column) + 'FechaRellena')"
        :readonly="!!form && (rangoRapidoActivo || !!form.getValue(getPathName(column) + 'FechaVacia') || !!form.getValue(getPathName(column) + 'FechaRellena'))"
        :overrideReadonly="true"
        floating-label
        outline
        :label="$t('common.desde')"
        :form="form"
        type="datepicker"
        :name="getPathName(column) + 'Desde'"
        :clearButton="true"
        :viewTooltip="viewTooltip"
        :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
      ></r-input>
      <r-input
        v-if="!!form && !form.getValue(getPathName(column) + 'FechaVacia') && !form.getValue(getPathName(column) + 'FechaRellena')"
        ref="fechaHasta"
        :readonly="!!form && (rangoRapidoActivo || !!form.getValue(getPathName(column) + 'FechaVacia') || !!form.getValue(getPathName(column) + 'FechaRellena'))"
        outline
        floating-label
        :label="$t('common.hasta')"
        :form="form"
        type="datepicker"
        :name="getPathName(column) + 'Hasta'"
        :clearButton="true"
        :viewTooltip="viewTooltip"
        :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
      ></r-input>
    </template>
    <div v-else class="template-flex">
      <r-input v-if="getValue(column, 'tipo') == 'FECHA'"
        class="template-item-flex"
        outline
        floating-label
        :label="$t(column.nombre)"
        :form="form"
        type="datepicker"
        :name="getPathName(column)"
        :clearButton="true"
        :viewTooltip="viewTooltip"
        :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit' } }"
      ></r-input>
      <r-input v-if="getValue(column, 'tipo') == 'FECHAHORA'"
        class="template-item-flex"
        outline
        floating-label
        :label="$t(column.nombre)"
        :form="form"
        type="datetime-local"
        :name="getPathName(column)"
        :readonly="readonly"
        :overrideReadonly="true"
        :calendar-params="{timePickerPlaceholder:'Seleccionar hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
        :ignorePreviousVal="true"
        :formatDate="'DD/MM/YYYY HH:mm'"
      ></r-input>
      <f7-list-item
        checkbox
        title="Vaciar campo"
        v-if="getValueOpcion(column, 'vaciarCampo')"
        @change="changeVaciarCampo($event, getPathName(column))"
      >
      </f7-list-item>
    </div>
  </div>
  <div v-else-if="getValue(column, 'tipo') == 'BOOLEAN'" :class="{'label-group': tipo == 'FILTRO'}">
    <template v-if="tipo == 'FILTRO'">
      <li><label>{{$t(column.nombre)}}</label></li>
      <r-input
        ref="booleanSI"
        :readonly="!!form && (!!form.getValue(getPathName(column) + 'CampoVacio') || !!form.getValue(getPathName(column) + 'CampoRelleno'))"
        :label="$t('common.yes')"
        :form="form"
        :simple="true"
        type="check"
        :name="getPathName(column) + 'BOOLEANSI'"
      ></r-input>
      <r-input
        ref="booleanNO"
        :readonly="!!form && (!!form.getValue(getPathName(column) + 'CampoVacio') || !!form.getValue(getPathName(column) + 'CampoRelleno'))"
        :label="$t('common.no')"
        :form="form"
        :simple="true"
        type="check"
        :name="getPathName(column) + 'BOOLEANNO'"
      ></r-input>
      <r-input
        v-if="tipo == 'FILTRO' && (!column.filtro || column.filtro.operation != 'EXISTS')"
        ref="campoVacio"
        floating-label
        outline
        :label="$t('common.campoVacio')"
        :form="form"
        :simple="true"
        type="check"
        :name="getPathName(column) + 'CampoVacio'"
        @change="campoVacio"
      ></r-input>
      <r-input
        v-if="tipo == 'FILTRO' && (!column.filtro || column.filtro.operation != 'EXISTS')"
        ref="campoRelleno"
        floating-label
        outline
        :label="$t('common.campoRelleno')"
        :form="form"
        :simple="true"
        type="check"
        :name="getPathName(column) + 'CampoRelleno'"
        @change="campoRelleno"
      ></r-input>
    </template>
    <template v-else>
      <f7-list-item
        checkbox
        :title="'Cambiar ' + $t(column.nombre)"
        @change="changeBooleanActivo"
      >
      </f7-list-item>
      <r-input
        v-if="booleanCambioMasivoActivar"
        ref="booleanChange"
        outline
        :label="$t(column.nombre)"
        :form="form"
        type="check"
        :name="getPathName(column)"
        :viewTooltip="viewTooltip"
      ></r-input>
    </template>
  </div>
  <div v-else-if="getValue(column, 'tipo') == 'IMPORTE'" :class="{'label-group': tipo == 'FILTRO'}">
    <template v-if="tipo == 'FILTRO'">
      <li><label>{{$t(column.nombre)}}</label></li>
      <r-input
        floating-label
        outline
        :label="$t('common.desde')"
        :form="form"
        type="number"
        step=".01"
        :name="getPathName(column) + 'Desde'"
        :clearButton="true"
        :viewTooltip="viewTooltip"
      ></r-input>
      <r-input
        outline
        floating-label
        :label="$t('common.hasta')"
        :form="form"
        type="number"
        step=".01"
        :name="getPathName(column) + 'Hasta'"
        :clearButton="true"
        :viewTooltip="viewTooltip"
      ></r-input>
    </template>
    <r-input
      v-else
      outline
      floating-label
      :label="$t(column.nombre)"
      :form="form"
      type="number"
      step=".01"
      :name="getPathName(column)"
      :clearButton="true"
      :viewTooltip="viewTooltip"
    ></r-input>
  </div>
  <div v-else-if="getValue(column, 'tipo') == 'NUMERO'" :class="{'template-flex': tipo == 'MASIVO'}">
    <r-input
      ref="campoNormal"
      :readonly="!!form && (!!form.getValue(getPathName(column) + 'CampoVacio') || !!form.getValue(getPathName(column) + 'CampoRelleno'))"
      floating-label
      outline
      :label="$t(column.nombre)"
      :form="form"
      type="number"
      :class="{'template-item-flex': tipo == 'MASIVO'}"
      :clearButton="true"
      :viewTooltip="viewTooltip"
      :name="getPathName(column)"
    ></r-input>
    <r-input
      v-if="tipo == 'FILTRO'"
      ref="campoVacio"
      floating-label
      outline
      :label="$t('common.campoVacio')"
      :form="form"
      :simple="true"
      type="check"
      :name="getPathName(column) + 'CampoVacio'"
      @change="campoVacio"
     ></r-input>
    <r-input
      v-if="tipo == 'FILTRO'"
      ref="campoRelleno"
      floating-label
      outline
      :label="$t('common.campoRelleno')"
      :form="form"
      :simple="true"
      type="check"
      :name="getPathName(column) + 'CampoRelleno'"
      @change="campoRelleno"
     ></r-input>
    <f7-list-item
      v-if="tipo == 'MASIVO' && getValueOpcion(column, 'vaciarCampo')"
      checkbox
      title="Vaciar campo"
      @change="changeVaciarCampo($event, getPathName(column))"
    >
    </f7-list-item>
  </div>
  <div v-else-if="getValue(column, 'tipo') == 'SELECT'" :class="{'template-flex': tipo == 'MASIVO'}">
    <!-- Columna SELECT con «OTRA»: `cambioMasivo.opciones.valorOtro` cambia el autocompletar por un
         desplegable de valores fijos más una opción que pide el valor escrito a mano (ver rSelectOtro). -->
    <r-select-otro
      v-if="tipo == 'MASIVO' && getValueOpcion(column, 'valorOtro')"
      ref="campoNormal"
      class="template-item-flex"
      :form="form"
      :name="getPathName(column)"
      :label="$t(column.nombre)"
      :items="getValue(column, 'items') || []"
      :idProp="getValue(column, 'idProp') || 'valor'"
      :labelProp="getValue(column, 'labelProp') || 'nombre'"
      :valorOtro="getValueOpcion(column, 'valorOtro')"
      :labelOtro="getValueOpcion(column, 'labelOtro') || getValueOpcion(column, 'valorOtro')"
      :viewTooltip="viewTooltip"
    ></r-select-otro>
    <r-autocomplete
      v-else
      ref="campoNormal"
      :readonly="!!form && (!!form.getValue(getPathName(column) + 'CampoVacio') || !!form.getValue(getPathName(column) + 'CampoRelleno'))"
      floating-label
      outline
      :class="{'template-item-flex': tipo == 'MASIVO'}"
      :model="getValue(column, 'model')"
      :label="$t(column.nombre)"
      :dbItems="getValue(column, 'items')"
      :form="form"
      :name="getPathName(column)"
      :idProp="getValue(column, 'idProp')"
      :labelProp="getValue(column, 'labelProp')"
      :prefixProp="getValueOpcion(column, 'prefixProp')"
      :async="getValue(column, 'async')"
      :minLength="getValue(column, 'minLength')"
      :viewTooltip="viewTooltip"
      :clearButton="true"
      :shownFields="getValue(column, 'shownFields')"
    ></r-autocomplete>
    <r-input
      v-if="tipo == 'FILTRO'"
      ref="campoVacio"
      floating-label
      outline
      :label="$t('common.campoVacio')"
      :form="form"
      :simple="true"
      type="check"
      :name="getPathName(column) + 'CampoVacio'"
      @change="campoVacio"
    ></r-input>
    <r-input
      v-if="tipo == 'FILTRO'"
      ref="campoRelleno"
      floating-label
      outline
      :label="$t('common.campoRelleno')"
      :form="form"
      :simple="true"
      type="check"
      :name="getPathName(column) + 'CampoRelleno'"
      @change="campoRelleno"
    ></r-input>
    <f7-list-item
      v-if="tipo == 'MASIVO' && getValueOpcion(column, 'vaciarCampo')"
      checkbox
      title="Vaciar campo"
      @change="changeVaciarCampo($event, getPathName(column))"
    >
    </f7-list-item>
  </div>
  <div v-else-if="getValue(column, 'tipo') == 'MULTISELECT'" :class="{'template-flex': tipo == 'MASIVO'}">
    <r-autocomplete-m2m
      ref="campoNormal"
      :readonly="!!form && (!!form.getValue(getPathName(column) + 'CampoVacio') || !!form.getValue(getPathName(column) + 'CampoRelleno'))"
      class="col-100"
      floating-label
      :class="{'template-item-flex': tipo == 'MASIVO'}"
      outline
      :model="getValue(column, 'model')"
      :label="$t(column.nombre)"
      :dbItems="getValue(column, 'items')"
      :form="form"
      :name="getPathName(column)"
      type="textarea"
      :lineBreak="true"
      :idProp="getValue(column, 'idProp')"
      :labelProp="getValue(column, 'labelProp')"
      :prefixProp="getValueOpcion(column, 'prefixProp')"
      :viewTooltip="viewTooltip"
      :shownFields="getValue(column, 'shownFields')"
    ></r-autocomplete-m2m>
    <r-input
      v-if="tipo == 'FILTRO'  && !getValueOpcion(column, 'noMostrarRellenoVacio') "
      ref="campoVacio"
      floating-label
      outline
      :label="$t('common.campoVacio')"
      :form="form"
      :simple="true"
      type="check"
      :name="getPathName(column) + 'CampoVacio'"
      @change="campoVacio"
    ></r-input>
    <r-input
      v-if="tipo == 'FILTRO'  && !getValueOpcion(column, 'noMostrarRellenoVacio')"
      ref="campoRelleno"
      floating-label
      outline
      :label="$t('common.campoRelleno')"
      :form="form"
      :simple="true"
      type="check"
      :name="getPathName(column) + 'CampoRelleno'"
      @change="campoRelleno"
    ></r-input>
    <f7-list-item
      v-if="tipo == 'MASIVO' && getValueOpcion(column, 'vaciarCampo')"
      checkbox
      title="Vaciar campo"
      @change="changeVaciarCampo($event, getPathName(column))"
    >
    </f7-list-item>
  </div> 
  <r-autocomplete-m2m
    v-else-if="getValue(column, 'tipo') == 'MES'"
    class="col-100"
    floating-label
    outline
    :model="getValue(column, 'model')"
    :label="$t(column.nombre)"
    :dbItems="getMeses()"
    :form="form"
    :name="getPathName(column)"
    type="textarea"
    :lineBreak="true"
    idProp="id"
    labelProp="nombre"
    :viewTooltip="viewTooltip"
  ></r-autocomplete-m2m>
  <r-autocomplete-m2m
    v-else-if="getValue(column, 'tipo') == 'ANYO'"
    class="col-100"
    floating-label
    outline
    :model="getValue(column, 'model')"
    :label="$t(column.nombre)"
    :dbItems="getAnyos(column)"
    :form="form"
    :name="getPathName(column)"
    type="textarea"
    :lineBreak="true"
    idProp="id"
    labelProp="nombre"
    :viewTooltip="viewTooltip"
  ></r-autocomplete-m2m>
  <div v-else  :class="{'template-flex': tipo == 'MASIVO'}">
    <r-input
      ref="campoNormal"
      floating-label
      :class="{'template-item-flex': tipo == 'MASIVO'}"
      outline
      :readonly="!!form && (!!form.getValue(getPathName(column) + 'CampoVacio') || !!form.getValue(getPathName(column) + 'CampoRelleno'))"
      :label="$t(column.nombre)"
      :form="form"
      type="text"
      :clearButton="true"
      :viewTooltip="viewTooltip"
      :name="getPathName(column)"
    ></r-input>
    <r-input
      v-if="tipo == 'FILTRO'"
      ref="campoVacio"
      floating-label
      outline
      :label="$t('common.campoVacio')"
      :form="form"
      :simple="true"
      type="check"
      :name="getPathName(column) + 'CampoVacio'"
      @change="campoVacio"
     ></r-input>
    <r-input
      v-if="tipo == 'FILTRO'"
      ref="campoRelleno"
      floating-label
      outline
      :label="$t('common.campoRelleno')"
      :form="form"
      :simple="true"
      type="check"
      :name="getPathName(column) + 'CampoRelleno'"
      @change="campoRelleno"
    ></r-input>
    <f7-list-item
      v-if="tipo == 'MASIVO' && getValueOpcion(column, 'vaciarCampo')"
      checkbox
      title="Vaciar campo"
      @change="changeVaciarCampo($event, getPathName(column))"
    >
    </f7-list-item>
  </div>
</template>
<style scoped>
.template-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.template-item-flex {
  flex: auto;
}
.label-group {
  margin-top: 20px;
  margin-left: 20px;
  font-weight: bold;
}
.filtro-icon i.f7-icons {
  color: #9e9e9e;
}
.filtro-icon-activo i.f7-icons {
  color: #1976d2;
}
.filtro-icon-activo {
  background: #e3f2fd;
  border-radius: 6px;
}
.filtro-iconos-rango {
  display: flex;
  gap: 14px;
  padding: 6px 0;
  align-items: center;
  justify-content: flex-start;
}
.filtro-nav-rango {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
  padding: 0;
}
/* los campos (checks y fechas) llevan el padding horizontal de las listas de f7:
   se quita para que queden alineados con el título y los iconos del filtro */
.filtro-fecha-group ::v-deep .item-content {
  padding-left: 0;
}
.filtro-nav-chip {
  font-size: 9px;
  line-height: 14px;
  padding: 1px 6px;
  border-radius: 8px;
  background: #e0e0e0;
  color: #333;
  font-weight: normal;
}
.filtro-nav-link i.f7-icons {
  font-size: 16px;
}
</style>
<script>

import rInput from "./rInput.vue";
import rAutocompleteM2m from "./rAutocompleteM2m.vue";
import rAutocomplete from "./rAutocomplete.vue";
import rSelectOtro from "./rSelectOtro.vue";

export default {
  components: {
    rSelectOtro,
    rInput,
    rAutocompleteM2m,
    rAutocomplete
  },
  data() {
    return {
      self: this,
      booleanCambioMasivoActivar: false
    };
  },
  props: {
    column: {
      required: true,
      type: Object
    },
    form: {
      type: Object
    },
    viewTooltip: {
      type: Boolean,
      default: true
    },
    tipo: {
      type: String,
      default: "FILTRO"
    }
  },
  mounted() {
    const self = this;
    if (self.getValue(self.column, 'tipo') == 'FECHA' && self.tipo == 'FILTRO') {
      let tieneFecha = false;
      let fDesde = self.form.getValue(self.getPathName(self.column) + 'Desde');
      let fHasta = self.form.getValue(self.getPathName(self.column) + 'Hasta');
      if (!!fDesde && self.$refs.fechaDesde && self.$refs.fechaDesde.setValue) {
        tieneFecha = true;
        self.$refs.fechaDesde.setValue([fDesde], "calendar");
      }
      if (!!fHasta && self.$refs.fechaHasta && self.$refs.fechaHasta.setValue) {
        tieneFecha = true;
        self.$refs.fechaHasta.setValue([fHasta], "calendar");
      }
      if (!tieneFecha) {
        const pathName = self.getPathName(self.column);
        const rangoActivo = self.rangosRapidos().find(r => !!self.form.getValue(pathName + r.suffix));
        if (rangoActivo) {
          self.aplicarRangoRapido(rangoActivo.ref, true);
        } else if (!!self.form.getValue(self.getPathName(self.column) + 'FechaVacia')) {
          self.setFechasVacias(true);
        } else if (!!self.form.getValue(self.getPathName(self.column) + 'FechaRellena')) {
          self.setFechasRellenas(true);
        }
      }
    }

  },
  computed: {
    chipFiltro() {
      const self = this;
      if (!self.form || !self.column) return '';
      if (self.getValue(self.column, 'tipo') !== 'FECHA' && self.getValue(self.column, 'tipo') !== 'FECHAHORA') return '';
      const pathName = self.getPathName(self.column);
      var desdeVal = self.form.getValue(pathName + 'Desde');
      var hastaVal = self.form.getValue(pathName + 'Hasta');
      if (Array.isArray(desdeVal)) desdeVal = desdeVal[0];
      if (Array.isArray(hastaVal)) hastaVal = hastaVal[0];
      if (!desdeVal || !hastaVal) return '';
      const desde = new Date(desdeVal);
      const hasta = new Date(hastaVal);
      if (desde.getFullYear() === hasta.getFullYear()
          && desde.getMonth() === hasta.getMonth()
          && desde.getDate() === hasta.getDate()) return 'Día';
      const esAnyoCompleto = desde.getDate() === 1 && desde.getMonth() === 0
        && desde.getFullYear() === hasta.getFullYear()
        && hasta.getMonth() === 11 && hasta.getDate() === 31;
      if (esAnyoCompleto) return 'Año';
      const ultimoDiaMes = new Date(hasta.getFullYear(), hasta.getMonth() + 1, 0).getDate();
      const esMesCompleto = desde.getDate() === 1
        && desde.getFullYear() === hasta.getFullYear()
        && desde.getMonth() === hasta.getMonth()
        && hasta.getDate() === ultimoDiaMes;
      if (esMesCompleto) return 'Mes';
      const diffDias = Math.round((hasta.getTime() - desde.getTime()) / 86400000) + 1;
      if (diffDias === 7 && desde.getDay() === 1) return 'Semana';
      return '';
    },
    rangoRapidoActivo() {
      const self = this;
      if (!self.form || !self.column) return false;
      const pathName = self.getPathName(self.column);
      return self.rangosRapidos().some(r => !!self.form.getValue(pathName + r.suffix));
    },
    rangoNavegacionLabel() {
      const self = this;
      if (!self.form || !self.column) return '';
      const pathName = self.getPathName(self.column);
      var desde = self.form.getValue(pathName + 'Desde');
      var hasta = self.form.getValue(pathName + 'Hasta');
      if (Array.isArray(desde)) desde = desde[0];
      if (Array.isArray(hasta)) hasta = hasta[0];
      if (!desde || !hasta) return '';
      const d = new Date(desde);
      const h = new Date(hasta);
      const pad = (n) => (n < 10 ? '0' + n : '' + n);
      const fmt = (x) => pad(x.getDate()) + '/' + pad(x.getMonth() + 1) + '/' + x.getFullYear();
      return fmt(d) + ' - ' + fmt(h);
    }
  },
  methods: {
    cleanData() {
      const self = this;
      self.cleanDataChildren(self.$children);

    },
    cleanDataChildren(children) {
      const self = this;
      if (children && Array.isArray(children) && children.length) {
        children.forEach(child => {
          if (child.setValue) {
            child.setValue(null);
          }
          self.cleanDataChildren(child.$children);
        });
      }
    },
    changeBooleanActivo (event) {
      const self = this;
      self.booleanCambioMasivoActivar = event.target.checked;
      if (!self.booleanCambioMasivoActivar) {
        self.$refs.booleanChange.setValue(null);
      }
    },
    changeVaciarCampo (event, name) {
      const self = this;
      let vaciar = event.target.checked;
      if (vaciar) {
        self.form.addInList('vaciarCampos', name);
      } else {
        self.form.removeFromList('vaciarCampos', name);
      }
    },
    getMeses () {
      const self = this;
      return [
        {id: 1, nombre: "01 - " + self.$t('Enero')},
        {id: 2, nombre: "02 - " + self.$t('Febrero')},
        {id: 3, nombre: "03 - " + self.$t('Marzo')},
        {id: 4, nombre: "04 - " + self.$t('Abril')},
        {id: 5, nombre: "05 - " + self.$t('Mayo')},
        {id: 6, nombre: "06 - " + self.$t('Junio')},
        {id: 7, nombre: "07 - " + self.$t('Julio')},
        {id: 8, nombre: "08 - " + self.$t('Agosto')},
        {id: 9, nombre: "09 - " + self.$t('Septiembre')},
        {id: 10, nombre: "10 - " + self.$t('Octubre')},
        {id: 11, nombre: "11 - " + self.$t('Noviembre')},
        {id: 12, nombre: "12 - " + self.$t('Diciembre')}
      ];
    },
    getAnyos (column) {
      let anyosAtras = column.filtro.opciones && column.filtro.opciones["anyosAtras"] ? column.filtro.opciones["anyosAtras"] : 5;
      let currentYear = new Date().getFullYear(); 
      var arr = [];
      for (let i = 0; i <= anyosAtras; i++) {
        arr.push({id: currentYear, nombre: "" + currentYear});
        currentYear--;
      }

      return arr;

    },
    rangosRapidos() {
      return [
        {ref: 'diaActual', suffix: 'DiaActual'},
        {ref: 'semanaActual', suffix: 'SemanaActual'},
        {ref: 'mesActual', suffix: 'MesActual'},
        {ref: 'anyoActual', suffix: 'AnyoActual'}
      ];
    },
    toggleFiltroFecha(refName, suffix) {
      const self = this;
      const pathName = self.getPathName(self.column);
      const current = !!(self.form && self.form.getValue(pathName + suffix));
      // Los rangos rápidos son readonly si Vacia o Rellena están activos
      if (self.rangosRapidos().some(r => r.ref === refName)
          && (!!self.form.getValue(pathName + 'FechaVacia') || !!self.form.getValue(pathName + 'FechaRellena'))) {
        return;
      }
      const newValue = !current;
      if (self.$refs[refName] && self.$refs[refName].setValue) {
        self.$refs[refName].setValue(newValue);
      }
      self.aplicarRangoRapido(refName, newValue);
    },
    diaActual (event) {
      const self = this;
      if (event && event.target) {
        self.aplicarRangoRapido('diaActual', event.target.checked);
      }
    },
    mesActual (event) {
      const self = this;
      if (event && event.target) {
        self.setFechasMesActual(event.target.checked);
      }
    },
    semanaActual (event) {
      const self = this;
      if (event && event.target) {
        self.setFechasSemanaActual(event.target.checked);
      }
    },
    anyoActual (event) {
      const self = this;
      if (event && event.target) {
        self.aplicarRangoRapido('anyoActual', event.target.checked);
      }
    },
    fechaVacia (event) {
      const self = this;
      if (event && event.target) {
        self.setFechasVacias(event.target.checked);
      }
    },
    fechaRellena (event) {
      const self = this;
      if (event && event.target) {
        self.setFechasRellenas(event.target.checked);
      }
    },
    campoVacio (event) {
      const self = this;
      if (event && event.target) {
        self.setCamposVacios(event.target.checked);
      }
    },
    campoRelleno (event) {
      const self = this;
      if (event && event.target) {
        self.setCamposRellenos(event.target.checked);
      }
    },
    setFechasMesActual(isChecked) {
      this.aplicarRangoRapido('mesActual', isChecked);
    },
    setFechasSemanaActual(isChecked) {
      this.aplicarRangoRapido('semanaActual', isChecked);
    },
    calcularRangoRapido(refName) {
      var hoy = new Date();
      if (refName === 'diaActual') {
        var dia = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
        return {desde: dia, hasta: dia};
      }
      if (refName === 'semanaActual') {
        var day = hoy.getDay();
        var offsetLunes = day === 0 ? -6 : 1 - day;
        var lunes = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + offsetLunes);
        var domingo = new Date(lunes.getFullYear(), lunes.getMonth(), lunes.getDate() + 6);
        return {desde: lunes, hasta: domingo};
      }
      if (refName === 'mesActual') {
        return {
          desde: new Date(hoy.getFullYear(), hoy.getMonth(), 1),
          hasta: new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0)
        };
      }
      if (refName === 'anyoActual') {
        return {
          desde: new Date(hoy.getFullYear(), 0, 1),
          hasta: new Date(hoy.getFullYear(), 11, 31)
        };
      }
      return null;
    },
    aplicarRangoRapido(refName, isChecked) {
      const self = this;
      const pathName = self.getPathName(self.column);
      if (isChecked) {
        // sólo puede haber un rango rápido activo a la vez
        self.rangosRapidos().forEach(r => {
          if (r.ref !== refName && self.form && !!self.form.getValue(pathName + r.suffix)
              && self.$refs[r.ref] && self.$refs[r.ref].setValue) {
            self.$refs[r.ref].setValue(false);
          }
        });
        var rango = self.calcularRangoRapido(refName);
        if (!rango) return;
        self.setRangoFechas(rango.desde, rango.hasta);
      } else {
        self.setRangoFechas(null, null);
      }
    },
    setRangoFechas(desde, hasta) {
      const self = this;
      if (self.$refs.fechaDesde && self.$refs.fechaDesde.setValue) {
        self.$refs.fechaDesde.setValue(desde ? [desde] : null, "calendar");
      }
      if (self.$refs.fechaHasta && self.$refs.fechaHasta.setValue) {
        self.$refs.fechaHasta.setValue(hasta ? [hasta] : null, "calendar");
      }
    },
    navegarFecha(direction) {
      const self = this;
      const pathName = self.getPathName(self.column);
      var desdeVal = self.form && self.form.getValue(pathName + 'Desde');
      var hastaVal = self.form && self.form.getValue(pathName + 'Hasta');
      if (Array.isArray(desdeVal)) desdeVal = desdeVal[0];
      if (Array.isArray(hastaVal)) hastaVal = hastaVal[0];
      if (!desdeVal || !hastaVal) return;
      var desde = new Date(desdeVal);
      var hasta = new Date(hastaVal);
      var ultimoDiaMes = new Date(hasta.getFullYear(), hasta.getMonth() + 1, 0).getDate();
      var esAnyoCompleto = desde.getDate() === 1 && desde.getMonth() === 0
        && desde.getFullYear() === hasta.getFullYear()
        && hasta.getMonth() === 11 && hasta.getDate() === 31;
      var esMesCompleto = desde.getDate() === 1
        && desde.getFullYear() === hasta.getFullYear()
        && desde.getMonth() === hasta.getMonth()
        && hasta.getDate() === ultimoDiaMes;
      var newDesde;
      var newHasta;
      if (esAnyoCompleto) {
        var newYear = desde.getFullYear() + direction;
        newDesde = new Date(newYear, 0, 1);
        newHasta = new Date(newYear, 11, 31);
      } else if (esMesCompleto) {
        var newMonth = desde.getMonth() + direction;
        newDesde = new Date(desde.getFullYear(), newMonth, 1);
        newHasta = new Date(desde.getFullYear(), newMonth + 1, 0);
      } else {
        var diffDias = Math.round((hasta.getTime() - desde.getTime()) / 86400000) + 1;
        newDesde = new Date(desde.getFullYear(), desde.getMonth(), desde.getDate() + direction * diffDias);
        newHasta = new Date(hasta.getFullYear(), hasta.getMonth(), hasta.getDate() + direction * diffDias);
      }
      // al navegar el rango ya no es el actual: se desmarca el icono
      self.rangosRapidos().forEach(r => {
        if (self.form && !!self.form.getValue(pathName + r.suffix)
            && self.$refs[r.ref] && self.$refs[r.ref].setValue) {
          self.$refs[r.ref].setValue(false);
        }
      });
      self.setRangoFechas(newDesde, newHasta);
    },
    setFechasVacias(isChecked) {
      const self = this;
      if (isChecked) {
        if (self.$refs.fechaDesde && self.$refs.fechaDesde.setValue) {
          self.$refs.fechaDesde.setValue(null, "calendar");
        }
        if (self.$refs.fechaHasta && self.$refs.fechaHasta.setValue) {
          self.$refs.fechaHasta.setValue(null, "calendar");
        }
        self.rangosRapidos().forEach(r => {
          if (self.$refs[r.ref] && self.$refs[r.ref].setValue) {
            self.$refs[r.ref].setValue(false);
          }
        });
        if (self.$refs.fechaRellena && self.$refs.fechaRellena.setValue) {
          self.$refs.fechaRellena.setValue(false);
        }
      }
    },
    setFechasRellenas(isChecked) {
      const self = this;
      if (isChecked) {
        if (self.$refs.fechaDesde && self.$refs.fechaDesde.setValue) {
          self.$refs.fechaDesde.setValue(null, "calendar");
        }
        if (self.$refs.fechaHasta && self.$refs.fechaHasta.setValue) {
          self.$refs.fechaHasta.setValue(null, "calendar");
        }
        self.rangosRapidos().forEach(r => {
          if (self.$refs[r.ref] && self.$refs[r.ref].setValue) {
            self.$refs[r.ref].setValue(false);
          }
        });
        if (self.$refs.fechaVacia && self.$refs.fechaVacia.setValue) {
          self.$refs.fechaVacia.setValue(false);
        }
      }
    },
    setCamposVacios(isChecked) {
      const self = this;
      if (isChecked) {
        if (self.$refs.campoNormal) {
          self.$refs.campoNormal.setValue(null);
        }
        if (self.$refs.booleanNO) {
          self.$refs.booleanNO.setValue(null);
        }
        if (self.$refs.booleanSI) {
          self.$refs.booleanSI.setValue(null);
        }
        if (self.$refs.campoRelleno) {
          self.$refs.campoRelleno.setValue(false);
        }
      } 
    },
    setCamposRellenos(isChecked) {
      const self = this;
      if (isChecked) {
        if (self.$refs.campoNormal) {
          self.$refs.campoNormal.setValue(null);
        }
        if (self.$refs.booleanNO) {
          self.$refs.booleanNO.setValue(null);
        }
        if (self.$refs.booleanSI) {
          self.$refs.booleanSI.setValue(null);
        }
        if (self.$refs.campoVacio) {
          self.$refs.campoVacio.setValue(false);
        }
      } 
    },
    getValue: function(column, field) {
      const self = this;
      var value = column.filtro[field];
      if (self.tipo == "MASIVO") {
        var overrideFields = self.getValueOpcion(column, "overrideFields");
        if (overrideFields && Array.isArray(overrideFields) && overrideFields.indexOf(field) > -1) {
          value = column.cambioMasivo[field];
        } else {
          value = column.cambioMasivo[field] || column.filtro[field];
        }
      }
      return value;
    },
    getValueOpcion: function(column, opcion) {
      const self = this;
      var value = column.filtro.opciones && column.filtro.opciones[opcion] ? column.filtro.opciones[opcion] : undefined;
      if (self.tipo == "MASIVO" && column.cambioMasivo && column.cambioMasivo.opciones && column.cambioMasivo.opciones[opcion]) {
        value = column.cambioMasivo.opciones[opcion];
      }
      return value;
    },
    getPathName: function(column) {
      const self = this;
      var pathName = column.pathName;
      if (self.tipo == "FILTRO") {
        pathName = column.filtro.pathName || column.pathName;
        pathName = pathName.replaceAll(".", "##");
      } else if (self.tipo == "MASIVO") {
        pathName = column.cambioMasivo.pathName || column.pathName;
      }
      return pathName;
    }
  }
};
</script>